import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-numero-contrato',
  templateUrl: './text-numero-contrato.component.html',
  styleUrls: ['./text-numero-contrato.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNumeroContratoComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
